export default function SchedulerDay({ date, textColor, classNames, ...rest }) {
  return (
    <button
      key={date.getTime()}
      className={`d-flex flex-column align-items-center rounded text-capitalize border ${classNames}`}
      {...rest}
    >
      <small className={`${textColor} fw-bold pt-1`}>
        {new Date().getDate() === date.getDate()
          ? "Hoje"
          : date
              .toLocaleDateString("pt-BR", {
                weekday: "short",
              })
              .replace(`.`, ``)}
      </small>
      <span
        style={{ fontSize: `18px` }}
        className={`${textColor} fw-bold pb-1 px-3`}
      >
        {date.toLocaleString("pt-BR", { day: "numeric" })}
      </span>
    </button>
  );
}
